import script from "./AuthLogin.vue?vue&type=script&setup=true&lang=ts"
export * from "./AuthLogin.vue?vue&type=script&setup=true&lang=ts"

export default script